import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Navigation, ExternalLink, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { getCountryCoord } from '../lib/countryCoords';

export const ClientMiniMap = ({ client, height = 200 }) => {
    if (!client) return null;
    const precise = typeof client.lat === 'number' && typeof client.lng === 'number' && client.geo_precision && client.geo_precision !== 'none';
    const fallback = getCountryCoord(client.country);
    const lat = precise ? client.lat : fallback?.lat;
    const lng = precise ? client.lng : fallback?.lng;
    if (lat === undefined || lng === undefined) {
        return <p className="text-xs text-muted-foreground" data-testid="client-minimap-none">Posizione non disponibile: inserisci indirizzo e nazione.</p>;
    }
    const zoom = client.geo_precision === 'address' ? 15 : client.geo_precision === 'city' ? 11 : 5;
    const query = precise ? `${lat},${lng}` : encodeURIComponent([client.address, client.country].filter(Boolean).join(', '));
    const gmaps = `https://www.google.com/maps/search/?api=1&query=${query}`;
    const directions = `https://www.google.com/maps/dir/?api=1&destination=${query}`;
    const label = client.geo_precision === 'address' ? 'Indirizzo' : client.geo_precision === 'city' ? 'Città (indirizzo approssimato)' : 'Centro paese (indirizzo non geolocalizzato)';

    return (
        <div className="space-y-2" data-testid="client-minimap">
            <div className="rounded-sm overflow-hidden border" style={{ height }}>
                <MapContainer key={`${lat},${lng},${zoom}`} center={[lat, lng]} zoom={zoom} scrollWheelZoom={false} dragging={true} style={{ height: '100%', width: '100%' }}>
                    <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <CircleMarker center={[lat, lng]} radius={precise ? 9 : 14} pathOptions={{ color: '#fff', weight: 2, fillColor: '#D32F2F', fillOpacity: precise ? 0.9 : 0.5 }}>
                        <Tooltip permanent direction="top" offset={[0, -8]}>{client.company_name}</Tooltip>
                    </CircleMarker>
                </MapContainer>
            </div>
            <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
                <span className="inline-flex items-center gap-1"><MapPin size={12} /> {label}</span>
                <span className="ml-auto flex gap-2">
                    <Button asChild variant="outline" size="sm" className="h-7 text-xs">
                        <a href={gmaps} target="_blank" rel="noopener noreferrer" data-testid="client-minimap-open"><ExternalLink size={12} className="mr-1" /> Apri mappa</a>
                    </Button>
                    <Button asChild size="sm" className="h-7 text-xs btn-primary">
                        <a href={directions} target="_blank" rel="noopener noreferrer" data-testid="client-minimap-navigate"><Navigation size={12} className="mr-1" /> Naviga</a>
                    </Button>
                </span>
            </div>
        </div>
    );
};

export default ClientMiniMap;
